<template>
  <div class="commonWireTable">
    <template v-if="!modStatus">
      <b-table
        :items="wireItem.slice(0, -1)"
        :fields="wireFields"
        sticky-header="447px"
        :no-border-collapse="true"
        class="text-center orderManagement-common-wire-table-detail original"
      >
        <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
        <template #cell(code)="data">
          <template v-if="data.value == ''">-</template>
          <template v-else>{{ data.value }}</template>
        </template>
        <template #cell(chinese_name)="data">
          <template v-if="data.value == ''">-</template>
          <template v-else>{{ data.value }}</template>
        </template>
        <template #cell(furnaceCode)="data">
          <template v-if="data.value == ''">-</template>
          <template v-else>{{ data.value }}</template>
        </template>
        <template #cell(consumption)="data" style="">
          {{ data.value.toLocaleString("en-US") }}
        </template>
      </b-table>
    </template>
    <template v-else>
      <b-table
        :items="wireItem"
        :fields="modWireFields"
        sticky-header="447px"
        :no-border-collapse="true"
        class="text-center orderManagement-common-wire-table-detail mod"
      >
        <template v-slot:cell(index)="data">{{
          data.index + 1 != wireItem.length ? data.index + 1 : ""
        }}</template>
        <template #cell(scroll_no)="data">
          <template v-if="data.index + 1 != wireItem.length">
            <input
              type="text"
              @blur="checkChangeInput('scroll_no', data.index)"
              v-model="wireItem[data.index].scroll_no"
              style="width: 157px;height: 100%;"
              class="text-center"
            />
          </template>
        </template>
        <template #cell(consumption)="data">
          <template v-if="data.index + 1 != wireItem.length">
            <input
              type="number"
              min="0"
              @blur="checkChangeInput('consumption', data.index)"
              v-model="wireItem[data.index].consumption"
              style="width: 100%;height: 100%;"
              class="text-center"
            />
          </template>
        </template>
        <template v-slot:cell(del)="data">
          <template v-if="data.index + 1 != wireItem.length">
            <b-button
              size="sm"
              style="height: 21px;line-height: normal;line-height: 13px;background-color: #4b8c80;border-color: #4b8c80;"
              @click="onWireDeleteClicked(data.index)"
            >
              刪除
            </b-button>
          </template>
          <template v-else>
            <b-button
              size="sm"
              style="height: 21px;line-height: normal;line-height: 13px;background-color: #4b8c80;border-color: #4b8c80;"
              @click="onWireAddClicked()"
            >
              新增
            </b-button>
          </template>
        </template>
      </b-table>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "commonWireTable",
  props: {
    wireItem: {
      type: Array,
      default: []
    },
    reason: {
      type: Array,
      default: []
    },
    modStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      wireFields: [
        {
          key: "index",
          label: "項次",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "scroll_no",
          label: "線材捲號",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "code",
          label: "線材品號",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "chinese_name",
          label: "線材品名",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "furnaceCode",
          label: "爐號",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "consumption",
          label: "耗用量(KG)",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        }
      ],
      modWireFields: [
        {
          key: "index",
          label: "項次",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "scroll_no",
          label: "線材捲號",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "code",
          label: "線材品號",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "chinese_name",
          label: "線材品名",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "furnaceCode",
          label: "爐號",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "consumption",
          label: "耗用量(KG)",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
          key: "del",
          label: "刪除",
          sortable: false,
          class: "font-family-dfyuanstd-w5 table-col-hight"
        }
      ]
    };
  },
  created: function() {},
  mounted: function() {
    let vm = this;
  },
  components: {},
  watch: {},
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      selectPage: "getlogin/get_selectPage"
    })
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      set_alertMsg: "alertmodal/set_alertMsg",
      settimeout_alertModal: "alertmodal/settimeout_alertModal"
    }),
    onWireAddClicked() {
      let vm = this;
      vm.wireItem.push({
        index: "",
        in_scroll_no: "",
        scroll_no: "",
        orgScroll_no: "",
        code: "",
        chinese_name: "",
        furnaceCode: "",
        in_consumption: "",
        consumption: "",
        orgConsumption: "",
        org_code: "",
        reason: [],
        del: ""
      });
    },
    onWireDeleteClicked(index) {
      let vm = this;
      vm.wireItem.splice(index, 1);
    },
    checkChangeInput(position, index = null) {
      let vm = this;
      switch (position) {
        case "scroll_no":
          console.log("scroll_no");
          let scroll_no = vm.wireItem[index].scroll_no;
          if (scroll_no == "" || scroll_no == undefined) {
            vm.wireItem[index].scroll_no = vm.wireItem[index].orgScroll_no;
            vm.set_alertMsg(`線材捲號不可為空，請再次確認`);
            vm.settimeout_alertModal();
            return;
          }
          for (let i = 0; i < vm.wireItem.length - 1; i++) {
            if (i == index) {
              continue;
            }
            if (vm.wireItem[i]["scroll_no"] == scroll_no) {
              vm.wireItem[index].scroll_no = vm.wireItem[index].orgScroll_no;
              vm.set_alertMsg(`線材捲號已存在，請再次確認`);
              vm.settimeout_alertModal();
              return;
            }
          }
          var params = {};
          params["vuePage"] = vm.selectPage;
          params["methods"] = "POST";
          params["scroll_no"] = scroll_no;
          params["whichFunction"] = "checkChangeInput";
          vm.axiosAction(params).then(() => {
            var result = vm.axiosResult;
            console.log(result.QueryTableData);
            if (result["Response"] == "ok") {
              vm.wireItem[index].code = result.QueryTableData.code;
              vm.wireItem[index].chinese_name =
                result.QueryTableData.chinese_name;
              vm.wireItem[index].furnaceCode =
                result.QueryTableData.furnaceCode;
              vm.wireItem[index].org_code = result.QueryTableData.org_code;
              vm.wireItem[index].orgScroll_no = scroll_no;

              var queryIndex = vm.wireItem[index].reason.indexOf("scroll_no");
              if (vm.wireItem[index].in_scroll_no != scroll_no) {
                if (queryIndex == -1) {
                  vm.wireItem[index].reason.push("scroll_no");
                }
              } else {
                //舊的跟新的一樣
                if (queryIndex != -1) {
                  vm.wireItem[index].reason.splice(queryIndex, 1);
                }
              }
            } else {
              vm.set_alertMsg(`查無此線材捲號，請再次確認`);
              vm.settimeout_alertModal();
              vm.wireItem[index].scroll_no = vm.wireItem[index].orgScroll_no;
              return;
            }
          });
          break;
        case "consumption":
          console.log("consumption");
          let consumption = vm.wireItem[index].consumption;
          if (consumption < 0 || consumption == "" || isNaN(consumption)) {
            vm.wireItem[index].consumption = vm.wireItem[index].orgConsumption;
            vm.set_alertMsg(`耗用量僅能是正數，請再次確認`);
            vm.settimeout_alertModal();
            return;
          }
          vm.wireItem[index].orgConsumption = consumption;

          var queryIndex = vm.wireItem[index].reason.indexOf("consumption");
          if (vm.wireItem[index].in_consumption != consumption) {
            if (queryIndex == -1) {
              vm.wireItem[index].reason.push("consumption");
            }
          } else {
            //舊的跟新的一樣
            if (queryIndex != -1) {
              vm.wireItem[index].reason.splice(queryIndex, 1);
            }
          }
          break;

        default:
          break;
      }
    }
  },
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
<style lang="scss">
.orderManagement-common-wire-table-detail > table > thead > tr > th {
  z-index: 1 !important;
}
.orderManagement-common-wire-table-detail th,
.orderManagement-common-wire-table-detail td {
  height: 2.5rem;
  min-width: 65px;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-right: 1px solid;
  border-bottom: 1px solid #999999 !important;
  font-size: 1.125rem;
  font-weight: normal;
  vertical-align: middle !important;
}
.orderManagement-common-wire-table-detail td {
  font-size: 1rem;
}
.orderManagement-common-wire-table-detail th:first-child,
.orderManagement-common-wire-table-detail td:first-child {
  border-left: 1px solid;
}
.orderManagement-common-wire-table-detail thead th {
  color: #ffffff !important;
  background-color: #4b8c80 !important;
}
.orderManagement-common-wire-table-detail.original tr th:nth-child(1),
.orderManagement-common-wire-table-detail.original tr td:nth-child(1) {
  width: 55px;
  min-width: 55px;
}
.orderManagement-common-wire-table-detail.original tr th:nth-child(2),
.orderManagement-common-wire-table-detail.original tr td:nth-child(2) {
  width: 175px;
  min-width: 175px;
}
.orderManagement-common-wire-table-detail.original tr th:nth-child(3),
.orderManagement-common-wire-table-detail.original tr td:nth-child(3) {
  width: 230px;
  min-width: 230px;
}
.orderManagement-common-wire-table-detail.original tr th:nth-child(4),
.orderManagement-common-wire-table-detail.original tr td:nth-child(4) {
  width: 485px;
  min-width: 485px;
}
.orderManagement-common-wire-table-detail.original tr th:nth-child(5),
.orderManagement-common-wire-table-detail.original tr td:nth-child(5) {
  width: 70px;
  min-width: 70px;
}
.orderManagement-common-wire-table-detail.original tr th:nth-child(6),
.orderManagement-common-wire-table-detail.original tr td:nth-child(6) {
  width: 110px;
  min-width: 110px;
}

.orderManagement-common-wire-table-detail.mod tr:last-child td:nth-child(n) {
  background-color: transparent;
  border-color: transparent !important;
}
.orderManagement-common-wire-table-detail.mod tr th:nth-child(1),
.orderManagement-common-wire-table-detail.mod tr td:nth-child(1) {
  width: 55px;
  min-width: 55px;
}
.orderManagement-common-wire-table-detail.mod tr th:nth-child(2),
.orderManagement-common-wire-table-detail.mod tr td:nth-child(2) {
  width: 175px;
  min-width: 175px;
}
.orderManagement-common-wire-table-detail.mod tr th:nth-child(3),
.orderManagement-common-wire-table-detail.mod tr td:nth-child(3) {
  width: 230px;
  min-width: 230px;
}
.orderManagement-common-wire-table-detail.mod tr th:nth-child(4),
.orderManagement-common-wire-table-detail.mod tr td:nth-child(4) {
  width: 395px;
  min-width: 395px;
}
.orderManagement-common-wire-table-detail.mod tr th:nth-child(5),
.orderManagement-common-wire-table-detail.mod tr td:nth-child(5) {
  width: 70px;
  min-width: 70px;
}
.orderManagement-common-wire-table-detail.mod tr th:nth-child(6),
.orderManagement-common-wire-table-detail.mod tr td:nth-child(6) {
  width: 110px;
  min-width: 110px;
}
.orderManagement-common-wire-table-detail.mod tr th:nth-child(7),
.orderManagement-common-wire-table-detail.mod tr td:nth-child(7) {
  width: 90px;
  min-width: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/orderManagement/table/commonWireTable.vue